import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

interface GetBackendAgentDeletedEntryIdsOptions {
  currentEntryIds: readonly string[];
  previousEntryIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentDeletedEntryIds({
  currentEntryIds,
  previousEntryIds,
  transaction
}: GetBackendAgentDeletedEntryIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const currentEntryIdSet = new Set(currentEntryIds);
  return previousEntryIds.filter((entryId) => !currentEntryIdSet.has(entryId));
}

export function isEntryOrderingChangeDeletionOnly({
  currentEntryIds,
  deletedEntryIds,
  previousEntryIds
}: {
  currentEntryIds: readonly string[];
  deletedEntryIds: readonly string[];
  previousEntryIds: readonly string[];
}): boolean {
  const deletedEntryIdSet = new Set(deletedEntryIds);
  const retainedEntryIds = previousEntryIds.filter(
    (entryId) => !deletedEntryIdSet.has(entryId)
  );

  return (
    retainedEntryIds.length === currentEntryIds.length &&
    retainedEntryIds.every((entryId, index) => entryId === currentEntryIds[index])
  );
}
